export function setBgPic(document: Document, show: boolean): void {
  const appID = document.getElementById("bgImg");
  if (appID != null) {
    const fild = [
      "RahelHermannSuedtirol.JPG",
      "3da6ecb2-06ee-44b5-8677-85b7a529cb44.jpg",
      "IMG_1584.jpg",
      "IMG_1653.jpg",
      "IMG_1656.jpg",
      "IMG_5986.jpg",
      "IMG_6039.jpg",
      "IMG_7739.jpg",
      "IMG_7794.jpg",
      "pan20200218_144106_04687.jpg"
    ];
    const sV = Math.round(Math.random() * (fild.length - 1));
    if (show) {
      appID.style.backgroundImage =
        "url('http://hermannarnekruse.com/kkHochzeit/bilder/bwBackground/" +
        fild[sV] +
        "')";
    } else {
      appID.style.backgroundImage = "none";
    }
  }
}
